import {CONTROL_SPECIAL_CONFIG_MIXIN} from "../../mixins/control-special-config-mixin";

export default {
    name: "BaseControlConfigSkeleton",
    mixins: [CONTROL_SPECIAL_CONFIG_MIXIN],
}